<template>
    <div class="info-list">
        <Header/>
        <div class="blank20"/>
        <div class="main-page-content contain-left-right">
            <div class="left-content">
                <div>
                    <div class="btn-item select">成绩查询</div>
                    <a href="/searchCer"><div class="btn-item">证书查询</div></a>
                </div>
                <div class="blank40"/>
                <div class="blank20"/>
                <div class="cx_list">
                    <form class="search-form">
                        <li class="t">考生姓名：</li>
                        <li class="in">
                            <input v-model="account" :disabled="score!==''" type="text" name="title">
                        </li>
                        <li class="t">身份证号：</li>
                        <li class="in">
                            <input v-model="card_num" :disabled="score!==''" type="text" name="sfzh">
                        </li>
                        <li v-if="score!==''" class="in">
                            <div style="text-align:center">考生成绩为：{{score}} 分</div>
                        </li>
                        
                        <li class="button">
                            <div v-if="score===''" class="btn default" @click="submit"> 查询 </div>
                        </li>
                    </form>
                </div>
            </div>
            <RightContent />
        </div>
        <div class="blank20"/>
        <Footer/>
    </div>
</template>
<script>
export default {
    data() {
        return {
            account:'',
            card_num:'',
            score:'',
        }
    },
    
    components:{
    },
    created() {
    },
    methods: {
        async submit(){
            if(this.account === ''){
                this.$toast('请输入考生姓名');
                return false;
            }else if(this.card_num === ''){
                this.$toast('请输入身份证号码');
                return false;
            }
            const params = {
                name:this.account,
                card_num:this.card_num
            }
            try {
                const res = await this.$http.get('/api/exam/getScore',params);
                if(res){
                    this.score = res.score;
                }
            } catch (error) {
                this.$toast(error.message||'请求失败');
            }
            
        }
    },
}
</script>
<style lang="scss" scoped>
.cx_list {
    width: 300px;
    padding: 20px;
    margin: 40px auto;
    background: #f2f9fd;
    border-radius: 10px;
    border: 1px solid #cdcac4;
}
.cx_list li{ padding:10px 5px; font-size:16px; height:40px; line-height:40px;}
.cx_list li.t{ text-align:right; width:80px; color:#333;display: inline-block;
    vertical-align: middle;}
.cx_list li.in{ width:200px; text-align:left;display: inline-block;
    vertical-align: middle;}
.cx_list li.in input{ border:1px solid #999; height:30px; width:200px; line-height:30px; border-radius:5px;}
.cx_list li .btn{ padding:10px 20px; background:#1c4585; color:#fff; margin:0 auto; border-radius:5px; border:0px; font-size:16px;}
.cx_list li.button{ width:300px; text-align:center;}
.btn-item{
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    height: 49px;
    line-height: 47px;
    font-size: 18px;
    color: #333;
    margin-right: 20px;
    padding: 0 20px;
    font-weight: 400;
}
.btn{
    width: 32px;
    height: 22px;
    line-height: 20px;
    cursor: pointer;
}
.select{
    font-weight: bold;
    background: #224899;
    color: #fff;
    border-radius: 30px;
}
</style>
